// extracted by mini-css-extract-plugin
export default {"errors":"Errors_errors__4vJMu","centered":"Errors_centered__koDtp"};